import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/agendar', pathMatch: 'full' },

  {
    path: 'errors',
    loadChildren: () =>
      import('./features/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'agendar',
    loadChildren: () =>
      import('./features/schedule-flow/schedule-flow.module').then(
        (m) => m.ScheduleFlowModule
      ),
  },
  {
    path: 'gestionar',
    loadChildren: () =>
      import('./features/manage/manage.module').then(
        (m) => m.ManageModule
      ),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
